import React from 'react';
import * as css from './WhatsAppPreview.css';
import {getTs,  tsToDate} from '../../../../library/dates';
import {useSelector} from 'react-redux';
import {convertVariablesToHtml} from '../../../../component/textEditor/Variables';
import {useVariables} from '../../../../assets/objects/Variables';
import {useTranslation} from 'react-i18next';
import sanitizeHtml from '../../../../library/sanitizeHtml';
import LinkIcon from './linkIcon/LinkIcon';
import {IS_NEW_TEMPLATE} from '../../../../config/config';
import {useBrandingParams} from '../../../../hooks/useBrandingParams';
import {toCamelCase} from '../../../../functions/camelSnakeCaseConversion';

function WhatsAppPreview({brandingPreview}) {
    const {messageType} = useBrandingParams();
    const {defaultVariables} = useVariables();
    const {t} = useTranslation('variables');
    const {value, whatsappContent, currentLang, whatsappPrefix, whatsappSuffix, whatsappButtons} = useSelector(s => ({
        currentLang: s.branding.currentLang,
        value: s.branding.data?.[s.branding.currentLang]?.[messageType]?.['whatsappMessage'] || '',
        whatsappContent: s.branding.data?.[s.branding.currentLang]?.[messageType]?.['whatsappContent'] || '',
        whatsappPrefix: s.branding.data?.[s.branding.currentLang]?.[messageType]?.['whatsappPrefix'] || '',
        whatsappSuffix: s.branding.data?.[s.branding.currentLang]?.[messageType]?.['whatsappSuffix'] || '',
        whatsappButtons: s.branding.data?.[s.branding.currentLang]?.[messageType]?.['whatsappButtons'] || [],
    }));
    const {isGivechak, isWhatsAppTemplate} = useSelector(s => ({
        isWhatsAppTemplate: IS_NEW_TEMPLATE(Number(s.event.eid)),
        isGivechak: s.event.type === 'givechak'
    }));

    const htmlWithValues = isWhatsAppTemplate ? convertVariablesToHtml(value, defaultVariables,t): convertVariablesToHtml(whatsappContent, defaultVariables,t);
    
    let text = `<p>${htmlWithValues}</p>`;
    text = text?.replace(/\\n/g, '</p><p>');

    return (   
        <css.wrapper data-cy={'whatsAppPreview'}>
            <css.title> 
                <css.profile />
                {brandingPreview||'Tickchak'}    
            </css.title>
            <css.messageContainer>
                <css.text dangerouslySetInnerHTML={sanitizeHtml(convertVariablesToHtml(whatsappPrefix, defaultVariables, t))} />
                <css.text time={tsToDate(getTs(), null, null, 'HH:mm')} dangerouslySetInnerHTML={sanitizeHtml(text)} />
                <css.text dangerouslySetInnerHTML={sanitizeHtml(convertVariablesToHtml(whatsappSuffix, defaultVariables, t))} />
                {isWhatsAppTemplate && !isGivechak && <css.buttonContainer>
                    {whatsappButtons.map((button, index) => (
                        <css.linkButton key={index}>
                            {t(toCamelCase((button.value).replace(/[[\]]/g, '')), {lng: currentLang})}
                            <LinkIcon />
                        </css.linkButton>
                    ))}
                </css.buttonContainer>}
            </css.messageContainer>
        </css.wrapper>
    );
}

export default WhatsAppPreview;
